import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions, BusinessStatus } from './index';
import { PaginationProps } from '../types';

export type BusinessListData = AnyObject

export type BusinessListResponse = BusinessListData
// eslint-disable-next-line max-len
export type BusinessListColumns = 'id' | 'name' | 'address' | 'zipCode' | 'type' | 'phone' | 'email' | 'website' | 'createdAt' | 'updatedAt';

export type BusinessListGetParams = PaginationProps<BusinessListColumns> & {
  search?: string;
  name?: string;
  address?: string;
  type?: string;
  email?: string;
  zipCode?: string;
  website?: string;
  phone?: string;
  user?: string;
  status?: BusinessStatus | null;
  updatedAtStart?: string;
  updatedAtEnd?: string;
}

export const businessListGet = (payload: BusinessListGetParams): Action<BusinessListGetParams> => ({
  type: actions.businessListTrigger.toString(),
  payload,
});

export const businessListClear = (): Action => ({
  type: actions.businessListClear.toString(),
});

export const businessListErrorClear = (): Action => ({
  type: actions.businessListErrorReset.toString(),
});

export function* businessListRequestSaga({ payload }: Action<BusinessListGetParams>) {
  yield put({
    type: actions.businessListStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.businessListError.toString(),
      payload: {
        message: 'BusinessList: Parameters not passed.',
      },
    });

    return;
  }

  const params = new URLSearchParams(Object.entries(payload).filter((entry) => !!entry[1]));

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/businesses?${params.toString()}`,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<BusinessListData, BusinessListResponse>(
    response,
    actions.businessListSuccess.toString(),
    actions.businessListError.toString(),
    false,
    (businessListData) => businessListData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.businessListTrigger.toString(),
    defaultProcessingSaga(
      businessListRequestSaga,
      {
        error: actions.businessListError.toString(),
        locationCancel: actions.businessListClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.businessListSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.businessListError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.businessListErrorReset.toString(),
    });
  });
}
